import React from "react";
import { leadValue, nextStepWhen, sourceColor, sourceLabel, stageColor, stageIcon, stageLabel, stallFlag } from "../lib/leads";
import { Badge } from "../ui";

export function StageBadge({ stage }) {
    return (
        <Badge color={stageColor(stage)}>
            <i className={stageIcon(stage)}></i> {stageLabel(stage)}
        </Badge>
    );
}

export function LeadSourceBadge({ source }) {
    if (!source) return null;
    return <Badge color={sourceColor(source)} title="Lead source">{sourceLabel(source)}</Badge>;
}

// Loud Stalled / No next step flag (solid), or nothing.
export function StallFlag({ lead, today, withDetail }) {
    const f = stallFlag(lead, today);
    if (!f) return null;
    return (
        <span className={`hz-flag hz-flag-${f.color}`} title={f.detail || "The lead has no next step or no date for it"}>
            <i className={f.kind === "stalled" ? "ri-alarm-warning-line" : "ri-error-warning-line"}></i>
            {f.label}
            {withDetail && f.detail ? ` · ${f.detail}` : ""}
        </span>
    );
}

export function LeadValue({ lead, empty = null }) {
    const v = leadValue(lead);
    if (!v) return empty;
    return (
        <span>
            <span className="hz-value hz-nowrap">{v.main}</span>{" "}
            {v.eur && <span className="hz-value-eur">{v.eur}</span>}
            {v.eurUnknown && <span className="hz-value-eur" title="No rate to EUR is set for this currency">EUR unknown</span>}
        </span>
    );
}

// Next step line with its date; red when stalled, amber when missing.
export function NextStepLine({ lead, today }) {
    if (!lead.is_open) {
        return lead.outcome_reason ? (
            <div className="hz-next">
                <i className={lead.stage === "won" ? "ri-trophy-line" : "ri-close-circle-line"}></i>
                <span>{lead.outcome_reason}</span>
            </div>
        ) : null;
    }
    const flag = stallFlag(lead, today);
    if (!lead.next_step || !lead.next_step_date) {
        return (
            <div className="hz-next warning">
                <i className="ri-flag-line"></i>
                <span>{lead.next_step ? `${lead.next_step} · no date` : "No next step set"}</span>
            </div>
        );
    }
    return (
        <div className={"hz-next" + (flag && flag.kind === "stalled" ? " danger" : "")}>
            <i className="ri-flag-line"></i>
            <span>
                {lead.next_step} · <span className="hz-nowrap hz-strong">{nextStepWhen(lead.next_step_date, today)}</span>
            </span>
        </div>
    );
}
